import React, { FC, ReactElement, useState } from "react";
import { MdCheckCircle, MdPanoramaFishEye } from "react-icons/md";
import {
  PASSWORD_MAX_LENGTH,
  PASSWORD_MIN_LENGTH,
} from "../../utils/app.config";
import {
  // validateEmail,
  hasUppercase,
  hasLowercase,
  hasNumber,
  hasSpecialcase,
} from "../../utils/validation";
type ForgetPasswordChangeProps = {
  submitData: Function;
  close: Function;
  address: string;
};

enum ErrorType {
  code,
  password,
  re_password,
  none,
}

interface Error {
  target: ErrorType;
  msg: string;
}

interface password_validation_Interface {
  uppercase: boolean;
  lowercase: boolean;
  number: boolean;
  length: boolean;
  special: boolean;
}

const ForgetPasswordChange: FC<ForgetPasswordChangeProps> = ({
  submitData,
  close,
  address,
}): ReactElement => {
  const [error, setError] = useState({
    target: ErrorType.none,
    msg: "",
  } as Error);
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [re_password, setRePassword] = useState("");
  const [password_validation, setPassword_validation] =
    useState<password_validation_Interface>({
      uppercase: false,
      lowercase: false,
      number: false,
      length: false,
      special: false,
    });
  const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // check for errors
    if (code.length <= 4) {
      setError({
        target: ErrorType.code,
        msg: "Required",
      });
      return false;
    }

    // // check for errors
    // if (password.length <= 4) {
    //   setError({
    //     target: ErrorType.password,
    //     msg: "Required",
    //   });
    //   return false;
    // }
    if (
      !(
        password_validation.uppercase &&
        password_validation.lowercase &&
        password_validation.number &&
        password_validation.special &&
        password_validation.length
      )
    ) {
      setError({
        target: ErrorType.password,
        msg: "Password must pass the validation test",
      });
      return false;
    }

    // // check for errors
    // if (re_password.length <= 4) {
    //   setError({
    //     target: ErrorType.re_password,
    //     msg: "Required",
    //   });
    //   return false;
    // }

    // check for errors
    if (re_password !== password) {
      setError({
        target: ErrorType.re_password,
        msg: "Passwords does not match",
      });
      return false;
    }

    // submit data
    submitData({ code, password });
  };

  const passwordOnChangeHandler = (password: string) => {
    setPassword(password);
    setError({ target: ErrorType.none, msg: "" });
    setPassword_validation({
      uppercase: hasUppercase(password),
      lowercase: hasLowercase(password),
      special: hasSpecialcase(password),
      number: hasNumber(password),
      length:
        password.length >= PASSWORD_MIN_LENGTH &&
        password.length < PASSWORD_MAX_LENGTH,
    } as password_validation_Interface);
  };

  let ValidationDesign = !(
    password_validation.uppercase &&
    password_validation.lowercase &&
    password_validation.number &&
    password_validation.special &&
    password_validation.length
  ) ? (
    <div className="px-2 mb-2 bg-white rounded shadow-lg mx-2 p-2 -mt-2">
      <div className="p-1 border-gray-200 border rounded-full flex">
        {password_validation.lowercase && (
          <div className="bg-blue-500 pt-1 rounded-l-full inline-block- w-1/6"></div>
        )}
        {password_validation.uppercase && (
          <div className="bg-blue-500 pt-1  inline-block- w-1/6"></div>
        )}
        {password_validation.number && (
          <div className="bg-blue-500 pt-1  inline-block- w-1/6"></div>
        )}
        {password_validation.length && (
          <div className="bg-blue-500 pt-1  inline-block- w-1/6"></div>
        )}
        {password_validation.special && (
          <div className="bg-blue-500 pt-1 rounded-r-full inline-block- w-2/6"></div>
        )}
      </div>

      <h5>Password must:</h5>
      <div className="pt-1 text-sm">
        <div
          className={`${
            password_validation.lowercase
              ? "text-green-600 font-bold"
              : "text-gray-500"
          }`}
        >
          {password_validation.lowercase ? (
            <MdCheckCircle className="inline-block" />
          ) : (
            <MdPanoramaFishEye className="inline-block" />
          )}{" "}
          <span>Include a lowercase character</span>
        </div>

        <div
          className={`${
            password_validation.uppercase
              ? "text-green-600 font-bold"
              : "text-gray-500"
          }`}
        >
          {password_validation.uppercase ? (
            <MdCheckCircle className="inline-block" />
          ) : (
            <MdPanoramaFishEye className="inline-block" />
          )}{" "}
          <span>Include an uppercase character</span>
        </div>

        <div
          className={`${
            password_validation.number
              ? "text-green-600 font-bold"
              : "text-gray-500"
          }`}
        >
          {password_validation.number ? (
            <MdCheckCircle className="inline-block" />
          ) : (
            <MdPanoramaFishEye className="inline-block" />
          )}{" "}
          <span>Include a Number</span>
        </div>

        <div
          className={`${
            password_validation.length
              ? "text-green-600 font-bold"
              : "text-gray-500"
          }`}
        >
          {password_validation.length ? (
            <MdCheckCircle className="inline-block" />
          ) : (
            <MdPanoramaFishEye className="inline-block" />
          )}{" "}
          <span>
            Between {PASSWORD_MIN_LENGTH} and {PASSWORD_MAX_LENGTH} character
          </span>
        </div>

        <div
          className={`${
            password_validation.special
              ? "text-green-600 font-bold"
              : "text-gray-500"
          }`}
        >
          {password_validation.special ? (
            <MdCheckCircle className="inline-block" />
          ) : (
            <MdPanoramaFishEye className="inline-block" />
          )}{" "}
          <span>A special character</span>
        </div>
      </div>
    </div>
  ) : null;

  return (
    <div className="mt-3 mx-auto max-w-screen-sm text-left animate__animated animate__zoomIn animate__faster">
      <form onSubmit={submitHandler}>
        <div className="bg-white shadow-lg p-4 rounded border-gray-700">
          <h2 className="text-2xl font-bold text-gray-600">Reset password</h2>
          <p className="text-gray-500">
            The se code has been sent to <b>{address}</b>, please reset the
            password and enter the code
          </p>

          <div className="mt-3">
            <div className="p-2 mt-2">
              <label htmlFor="code" className="d-block">
                Code
              </label>
              <input
                type="text"
                name="code"
                onChange={(e) => {
                  setCode(e.target.value);
                  setError({ target: ErrorType.none, msg: "" });
                }}
                className={`input-white w-1/2  ${
                  error?.target === ErrorType.code
                    ? "border-red-500 border-2"
                    : "input-border"
                }`}
                placeholder="Enter code"
                value={code}
              />
              {error?.target === ErrorType.code && (
                <span className="text-red-600">{error?.msg}</span>
              )}
            </div>
            <div className="p-2 mt-2">
              <label htmlFor="username" className="d-block">
                Password
              </label>
              <input
                type="password"
                name="password"
                onChange={(e) => passwordOnChangeHandler(e.target.value)}
                className={`input-white w-20 inline-block  ${
                  error?.target === ErrorType.password
                    ? "border-red-500 border-2"
                    : "input-border"
                }`}
                placeholder="Enter password"
                value={password}
              />
              {error?.target === ErrorType.password && (
                <span className="text-red-600">{error?.msg}</span>
              )}
            </div>{" "}
            {ValidationDesign}
            <div className="p-2 mt-2">
              <label htmlFor="username" className="d-block">
                Password
              </label>
              <input
                type="password"
                name="re_password"
                onChange={(e) => {
                  setRePassword(e.target.value);
                  setError({ target: ErrorType.none, msg: "" });
                }}
                className={`input-white w-20 inline-block  ${
                  error?.target === ErrorType.re_password
                    ? "border-red-500 border-2"
                    : "input-border"
                }`}
                placeholder="Re-Enter password"
                value={re_password}
              />
              {error?.target === ErrorType.re_password && (
                <span className="text-red-600">{error?.msg}</span>
              )}
            </div>
            <div className="flex items-center">
              <div className="">
                <button
                  type="button"
                  className="p-2 rounded bg-gray-200"
                  onClick={() => close()}
                >
                  Restart process
                </button>
              </div>
              <div className="p-2 text-right flex-1">
                <button
                  className={`py-2 font-bold  px-8 rounded bg-hero text-white inline-block`}
                  type="submit"
                >
                  Change password
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};
export default ForgetPasswordChange;
